import { TimeReport } from "@entities";
import { Box, Button } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { heIL } from "@mui/x-date-pickers/locales";
import { type HyperTableFilter } from "@shared/frontend/hyper-table";
import dayjs from "dayjs";

const toValidDate = (value: unknown): Date | null => {
  if (value == null) return null;
  const date = value instanceof Date ? value : new Date(value as string | number);
  return Number.isFinite(date.getTime()) ? date : null;
};

const filters: HyperTableFilter<TimeReport>[] = [
  { fieldName: "isConfirmed", id: "isConfirmed" },
  { fieldName: "association.user.name", id: "name" },
  { fieldName: "organizationManager.name", id: "managerName", caption: "מנהל" },
  {
    id: "dateRange",
    icon: "date",
    caption: "טווח תאריכים",
    renderFilter: ({ onSave, meta }) => {
      const startDate = toValidDate(meta.startDate);
      const endDate = toValidDate(meta.endDate);
      const buildFilter = (start: Date | null, end: Date | null) => {
        if (!start && !end) return {};
        return TimeReport.hyperFilter({
          date: {
            ...(start ? { $gte: dayjs(start).startOf("day").toDate() } : {}),
            ...(end ? { $lte: dayjs(end).endOf("day").toDate() } : {}),
          },
        });
      };
      return (
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          localeText={heIL.components.MuiLocalizationProvider.defaultProps.localeText}
          adapterLocale="he"
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1, p: 1 }}>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              <DatePicker
                label="מתאריך"
                value={startDate ? dayjs(startDate) : null}
                format="DD/MM/YYYY"
                onChange={(date) => {
                  const next = date ? dayjs(date).toDate() : null;
                  onSave({
                    value: buildFilter(next, endDate),
                    meta: { startDate: next, endDate },
                  });
                }}
                slotProps={{ textField: { size: "small" } }}
              />
              <DatePicker
                label="עד תאריך"
                value={endDate ? dayjs(endDate) : null}
                format="DD/MM/YYYY"
                onChange={(date) => {
                  const next = date ? dayjs(date).toDate() : null;
                  onSave({
                    value: buildFilter(startDate, next),
                    meta: { startDate, endDate: next },
                  });
                }}
                slotProps={{ textField: { size: "small" } }}
              />
            </Box>
            <Button
              variant="outlined"
              size="small"
              sx={{ alignSelf: "flex-start" }}
              onClick={() =>
                onSave({ value: {}, meta: { startDate: null, endDate: null } })
              }
            >
              נקה סינון
            </Button>
          </Box>
        </LocalizationProvider>
      );
    },
  },
];

export default filters;
